module.exports = __webpack_public_path__ + "static/media/Illustration.37f65650.png";